import { Routes } from '@angular/router';
import { authGuard } from './common/guards/auth.guard';
import { BackendGuidePage } from './pages/backend-guide/backend-guide.page';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPage),
  },
  {
    path: 'amenities',
    loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesPage),
  },
  {
    path: 'experience',
    loadComponent: () => import('./pages/gallery/gallery.page').then(m => m.GalleryPage),
  },
  {
    path: 'offers',
    loadComponent: () => import('./pages/offers/offers.page').then(m => m.OffersPage),
  },
  {
    path: 'offers/:slug',
    loadComponent: () => import('./pages/offer-detail/offer-detail.page').then(m => m.OfferDetailPage),
  },
  { path: 'services', redirectTo: 'amenities', pathMatch: 'full' },
  { path: 'gallery', redirectTo: 'experience', pathMatch: 'full' },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage),
  },
  {
    path: 'booking-info',
    loadComponent: () => import('./pages/booking-info/booking-info.page').then(m => m.BookingInfoPage),
  },
  {
    path: 'admin-guide',
    component: BackendGuidePage,
  },
  { path: 'backend-guide', redirectTo: 'admin-guide', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.page').then(m => m.DashboardPage),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout/logout.page').then(m => m.LogoutPage),
    canActivate: [authGuard],
  },
  {
    path: 'availability',
    loadComponent: () => import('./pages/availability/availability.page').then(m => m.AvailabilityPage),
    canActivate: [authGuard],
  },
  {
    path: 'view-booking',
    loadComponent: () => import('./pages/view-booking/view-booking.page').then(m => m.ViewBookingPage),
    canActivate: [authGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage),
  },
  {
    path: 'tnc',
    loadComponent: () => import('./pages/tnc/tnc.page').then(m => m.TncPage),
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
  },
  { path: '**', redirectTo: '404' },
];
